module.exports = __webpack_public_path__ + "img/speaker.c3ff13a0.jpg";